export const ROUTES = {
	HOME: "/",
	SPEAKERS: "/speakers",
	SCHEDULES: "/schedules",
	ORGANIZERS: "/organizers",
};

export const HEADER_ROUTES = [
	{
		path: ROUTES.HOME,
		title: "Home",
	},
	{
		path: ROUTES.SPEAKERS,
		title: "Speakers",
	},
	{
		path: ROUTES.SCHEDULES,
		title: "Schedules",
	},
	{
		path: ROUTES.ORGANIZERS,
		title: "Organizers",
	},
];
